import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useState } from "react";
import { BiTrash } from "react-icons/bi";
import { Button } from "../../components/ui/button";

dayjs.extend(relativeTime);

const ReportComment = ({ comment, isSelfComment, deleteComment, isDeleting }) => {
   const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
   return (
      <div className={`text-sm grid max-w-[70%] ${isSelfComment ? "justify-self-end" : "justify-self-start"}`}>
         {comment.deletedAt ? (
            <p className="italic bg-gray-100 p-4 rounded-lg text-gray-400">This comment was deleted</p>
         ) : (
            <div className={`comment | group grid bg-gray-100 p-4 text-sm gap-y-2 rounded-lg`}>
               <div className="flex justify-between items-center gap-x-8">
                  <div className="flex items-center gap-x-2 text-xs text-gray-400">
                     <span className="font-semibold">{`${comment.user.firstName} ${comment.user.lastName}`}</span>
                     <span className="divider | font-semibold text-base w-1 bg-gray-300 rounded-full aspect-square"></span>
                     <span className="italic">{dayjs(comment.createdAt).fromNow()}</span>
                  </div>
                  {isSelfComment ? (
                     <div className="comment-actions | invisible group-hover:visible">
                        <button onClick={() => setShowConfirmationDialog(true)}>
                           <BiTrash className="text-red-600" />
                        </button>
                     </div>
                  ) : null}
               </div>
               <p className="w-[100%]">{comment.content}</p>
            </div>
         )}
         {showConfirmationDialog && !Boolean(comment.deletedAt) ? (
            <div className="confirmation-dialog | my-4 text-gray-600">
               <p className="italic mb-2">Are you sure you want to delete this comment?</p>
               <div className="flex justify-end gap-x-3 !text-xs">
                  <Button variant="secondary" className="!px-5" onClick={() => setShowConfirmationDialog(false)}>
                     Cancel
                  </Button>
                  <Button variant="danger" onClick={() => deleteComment(comment.id)}>
                     {isDeleting ? "Deleting..." : "Yes, Delete"}
                  </Button>
               </div>
            </div>
         ) : null}
      </div>
   );
};

export { ReportComment };
